// extracted by css-extract-rspack-plugin
export default {"title":"title-tGH2Ns"};